import { useEffect, useRef, useState } from 'react';
import { Copy, Check } from 'lucide-react';

import AngryBirds from './AngryBirds';
import DigDug from './DigDug';
import fingerprint from '../images/train.png';
import WildChessApp from './Chess';

const TronLegacy = () => {
    const ref = useRef();
    const [gameshowing, setgameshowing] = useState(null);
    const [copied, setCopied] = useState(false);

    const copyEmail = () => {
        navigator.clipboard.writeText('rolandandrewforbes@gmail.com');
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    useEffect(() => {
        createSmoke(3, 8);
    }, []);

    function createSmoke(time, num) {
        const duration = 1;
        var timeGap = (time / num);
        for (var i = 0; i < num; i++) {
            var delay = (timeGap * i) + 's';
            var aniName = "smokeL";
            if (((i + 1) % 2) == 0) {
                aniName = "smokeR";
            }
            var aniStyle = "animation: " + aniName + " " + duration + "s " + delay + " infinite";
            if (ref.current) ref.current.innerHTML = ref.current.innerHTML + `<span class="smokepuff" style="${aniStyle}"></span>`;
        }

    }

    const renderUI = () => {

        if (gameshowing == 'digdug') {
            return <DigDug setgameshowing={setgameshowing} />
        } else if(gameshowing == 'angrybirds') {
            return <AngryBirds setgameshowing={setgameshowing} />;
        } else if(gameshowing == 'chess') {
            return <WildChessApp />
        } else {
            return <div className='fixed-center-xl'>
                <div className="border border-secondary terminal-portfolio">
                    <div>
                        <p className="border-bottom d-flex justify-content-between px-1 text-light">
                            <span className='fw-bold text-secondary'>ROLANDFORBES.txt</span>
                        </p>
                        <div className="mx-3 my-4">
                            <div className="row">
                                <div className="col-12 col-lg">
                                    <div className='h-100 d-flex flex-column justify-content-between gap-3'>
                                        <p className="px-2 text-light">
                                            <u>Hello!</u> <br /> <br />I'm Roland Forbes, a software engineer based in Bozeman, MT with 10 years of professional experience. I started my career as a front-end developer and grew into a full-stack engineer — comfortable everywhere from UI to databases to cloud infrastructure. <br /><br />Most recently I've been honing my skills managing agentic AI pipelines. Im a firm believer that the computer is the bicycle of the mind, and there has never been a better time to be a creator!
                                            <br /><br />
                                            <span className='d-flex gap-2'>
                                                <span className='text-warning fw-bold' style={{ whiteSpace: 'nowrap' }}>Web builds: </span>
                                                <span className='d-flex flex-column gap-1'>
                                                    <a href='/stompertrucks' target='_blank' rel='noreferrer' className='text-info'>stompertrucks.com</a>
                                                    <a href='/onjumprun' target='_blank' rel='noreferrer' className='text-info'>onjumprun.com</a>
                                                    <a href='/zencyclery' target='_blank' rel='noreferrer' className='text-info'>zencyclery.com</a>
                                                </span>
                                            </span>
                                            <br /> <br />
                                        </p>
                                        <span className='px-3 hide-on-mobile'>
                                            <h6 className='fs-2 mrs-saint-delafield-regular mb-0 text-light'>Roland Forbes</h6>
                                            <p className='fs-8 text-info d-flex align-items-center gap-2'>
                                                rolandandrewforbes@gmail.com
                                                <button onClick={copyEmail} style={{ background: 'none', border: 'none', color: '#0dcaf0', cursor: 'pointer', padding: '0', display: 'flex', alignItems: 'center' }}>
                                                    {copied ? <Check size={13} /> : <Copy size={13} />}
                                                </button>
                                            </p>
                                            <a href='https://gitlab.com/rolandforbes' target='_blank' rel='noreferrer' className='text-info'>gitlab.com/rolandforbes</a>
                                        </span>
                                    </div>
                                </div>
                                <div className="col position-relative">
                                    <div className='h-100 d-flex flex-column justify-content-between gap-2'>
                                        <div className='pe-2 d-none d-lg-block'>
                                            <img
                                                src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&fit=crop&q=80"
                                                alt="Bozeman, MT"
                                                style={{ width: '100%', aspectRatio: '16/9', objectFit: 'cover', display: 'block', borderRadius: '8px' }}
                                            />
                                            <div className='d-flex flex-wrap gap-2 mt-2'>
                                                {['Claude CLI', 'Agentic Pipelines', 'React', 'TypeScript', 'JavaScript', 'HTML/CSS', 'C#', '.NET Framework', 'Node.js', 'SQL', 'REST APIs', 'Git', 'Azure', 'AWS QuickSight'].map(skill => (
                                                    <span key={skill} className='skill-pill'>{skill}</span>
                                                ))}
                                            </div>
                                        </div>
                                        <div className='d-none d-lg-flex justify-content-end pe-3'>
                                            <div className='position-relative'>
                                                <span className='smokefaya' ref={ref}></span>
                                                <img src={fingerprint} height={82} className='opacity-75 mt-4 h-82' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
    }

    return renderUI();
}
export default TronLegacy;